import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-subtitle-1 text-medium-emphasis" }
const _hoisted_4 = { key: 1 }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'
import router from '@/router'
import { useMeta } from 'vue-meta'
import FooterComponent from '@/components/Footer/FooterComponent.vue'
import { hospitalAuthStore } from '@/stores/hospital-auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalForgotPassword',
  setup(__props) {

const { t } = useI18n()
const email = ref<string>('')
const isLoading = ref(false)
const responseStatus = ref({})

const emailRules = [
  (v: string) => !!v || t('email-required'),
  (v: string) => /.+@.+\..+/.test(v) || t('email-authentic'),
]

const isInfoCompleted = computed(() => {
  const isEmailInvalid = emailRules.some((rule) => {
    const result = rule(email.value)
    return typeof result === 'string'
  })

  return !isEmailInvalid
})
useMeta(
  computed(() => ({
    title: 'Medcircle',
  }))
)

const sendLink = async () => {
  isLoading.value = true
  const hospitalAuth = hospitalAuthStore()

  const credentials = {
    email: email.value,
  }
  const response = await hospitalAuth.forgotPassword(credentials)
  responseStatus.value = response
  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderComponent),
      _createVNode(_component_request_status, {
        response: responseStatus.value,
        isLoading: false
      }, null, 8, ["response"]),
      _createVNode(_component_v_card, {
        class: "mx-auto pa-12 pb-8 my-15",
        elevation: "8",
        "max-width": "548",
        rounded: "lg"
      }, {
        default: _withCtx(() => [
          (!responseStatus.value.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('account')), 1),
                _createVNode(_component_v_text_field, {
                  modelValue: email.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  density: "compact",
                  placeholder: _ctx.$t('email'),
                  "prepend-inner-icon": "mdi-email-outline",
                  rules: emailRules,
                  variant: "outlined",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (isInfoCompleted.value ? sendLink() : undefined), ["enter"]))
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_component_v_btn, {
                  class: "mb-8",
                  color: "blue",
                  size: "large",
                  variant: "flat",
                  block: "",
                  loading: isLoading.value,
                  disabled: !isInfoCompleted.value,
                  onClick: sendLink
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('reset-password')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]),
                _createVNode(_component_v_card_text, { class: "text-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "text-blue text-decoration-none",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/hospital-login'))),
                      style: {"cursor":"pointer"}
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('back-login')), 1),
                      _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_card_item, { style: {"font-family":"Verdana, Geneva, Tahoma, sans-serif"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('forgot-password-title')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('forgot-password-text')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      })
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})